import PropTypes from 'prop-types'
import { Fragment, useContext } from 'react'
import { AuthenticationContext } from '../../../context/authenticationContext'
import LogoIcon from '../../../graphics/LogoIcon'
import PostDate from '../../Utilities/PostDate'
import TextWrapper from '../../Utilities/TextWrapper'

export default function PrivateMessage({ modView, message }) {
  const { user } = useContext(AuthenticationContext)

  if (!user || message.toEveryone) {
    return <EveryoneMessage message={message} />
  }

  const loggedInUserIsSender =
    message.user.userService._id === user.userService._id

  const hasToUser = message.toUser !== undefined

  let messageFloat = 'float-left'

  if (modView) {
    if (hasToUser) {
      messageFloat = 'float-right'
    }
  } else {
    if (loggedInUserIsSender) {
      messageFloat = 'float-right'
    }
  }

  return (
    <div className="block w-full px-2">
      <div className={`w-3/4 ${messageFloat}`}>
        <div className="flex flex-row">
          {!message.toUser ? (
            <strong>
              <p
                className={`text-${message.user.userService.profile.color} mr-2`}
              >
                {message.user.userService.profile.name}
              </p>
            </strong>
          ) : (
            <strong>
              <p className={`text-neutral-700 dark:text-neutral-300 mr-2`}>
                Moderator{' '}
                <span
                  className={`text-${message.user.userService.profile.color} mr-2`}
                >
                  ({message.user.userService.profile.name})
                </span>
              </p>
            </strong>
          )}
        </div>
        <div
          className={`p-2 rounded-md ${
            messageFloat === 'float-left'
              ? 'border border-neutral-200 dark:border-neutral-900/50 bg-neutral-50 dark:bg-neutral-900/15'
              : 'border border-brand-primary-200 dark:border-brand-primary-900/50 bg-brand-primary-50 dark:bg-brand-primary-900/15'
          }`}
        >
          <TextWrapper
            text={message.message}
            renderLinks={hasToUser}
            element="p"
          />
        </div>
        <span className="text-xs text-gray-700 dark:text-gray-300">
          {message.itemNumber ? (
            <Fragment>
              From:{' '}
              <LogoIcon product={message.itemNumber} size="sm" displayName />
              {user.userService.settings.showTimestamps && (
                <Fragment>
                  {' at '}
                  <PostDate
                    date={
                      message.postDate ? message.postDate : message.postdate
                    }
                    source="privateMessage"
                  />
                </Fragment>
              )}
            </Fragment>
          ) : (
            <PostDate
              date={message.postDate ? message.postDate : message.postdate}
              source="privateMessage"
            />
          )}
        </span>
      </div>
    </div>
  )
}

// Define PropTypes for the component
PrivateMessage.propTypes = {
  modView: PropTypes.bool, // modView should be a boolean
  message: PropTypes.shape({
    user: PropTypes.shape({
      userService: PropTypes.shape({
        _id: PropTypes.string, // Assuming _id is a string
        profile: PropTypes.shape({
          color: PropTypes.string, // Assuming color is a string
          name: PropTypes.string // Assuming name is a string
        })
      })
    }),
    toUser: PropTypes.object, // toUser should be a boolean
    postDate: PropTypes.string, // Assuming postDate is a Date
    message: PropTypes.string, // message should be a string
    itemNumber: PropTypes.string // itemNumber should be a string
  })
}

const EveryoneMessage = ({ message }) => {
  return (
    <div className="block w-full px-2">
      <div className="px-2.5 py-3 bg-blue-50 dark:bg-blue-950 highlighted-glow rounded-xl border border-blue-500">
        <p className="text-xs mb-1">
          <strong
            className={`text-${message.user.userService.profile.color} bg-blue-100 dark:bg-blue-900 px-1.5 py-0.5 rounded-md`}
          >
            {message.user.userService.profile.name}
          </strong>
        </p>
        <TextWrapper text={message.message} renderLinks={true} element="p" />
      </div>
    </div>
  )
}
